import BaseService from '@/services/api/BaseService';
import {
    MetaConnectionStatusResult,
    MetaOAuthCallbackPayload,
    MetaOAuthStartResult,
    MetaWhatsAppNumberPolicy,
    MetaWhatsAppPhoneApprovalResult,
} from '@/types';

class MetaIntegrationService extends BaseService<never> {
    constructor() {
        super('whatsapp-business');
    }

    getConnectionStatus() {
        return this.http.get<MetaConnectionStatusResult>(`${this.route}/connection`);
    }

    startWhatsAppConnect() {
        return this.http.post<MetaOAuthStartResult>(`${this.route}/oauth/start`);
    }

    completeWhatsAppConnect(payload: MetaOAuthCallbackPayload) {
        return this.http.post<MetaConnectionStatusResult>(`${this.route}/oauth/callback`, payload);
    }

    confirmWhatsAppConnect(connectionId: string) {
        return this.http.post<MetaConnectionStatusResult>(`${this.route}/connection/confirm`, {
            connectionId,
        });
    }

    getWabas() {
        return this.http.get<MetaConnectionStatusResult[]>(`${this.route}/wabas`);
    }
    getWaba(wabaId: string) {
        return this.http.get<MetaConnectionStatusResult>(`${this.route}/wabas/${wabaId}`);
    }
    activateWaba(wabaId: string) {
        return this.http.post<MetaConnectionStatusResult>(`${this.route}/wabas/${wabaId}/activate`);
    }
    activatePhoneNumber(
        wabaId: string,
        phoneNumberId: string,
        pin: string,
        expectedVersion: number,
    ) {
        return this.http.post<MetaConnectionStatusResult>(
            `${this.route}/wabas/${wabaId}/phone-numbers/${phoneNumberId}/activate`,
            { pin, expectedVersion },
            { headers: { 'idempotency-key': crypto.randomUUID() } },
        );
    }
    getWhatsAppNumberPolicy() {
        return this.http.get<MetaWhatsAppNumberPolicy>(`${this.route}/number-policy`);
    }
    setWhatsAppPhoneApproval(
        wabaId: string,
        phoneId: number,
        approved: boolean,
        expectedVersion: number,
    ) {
        return this.http.put<MetaWhatsAppPhoneApprovalResult>(
            `${this.route}/wabas/${wabaId}/phone-numbers/${phoneId}/approval`,
            { approved, expectedVersion },
            { headers: { 'idempotency-key': crypto.randomUUID() } },
        );
    }
    synchronizeWaba(wabaId: string) {
        return this.http.post<MetaConnectionStatusResult>(
            `${this.route}/wabas/${wabaId}/synchronize`,
        );
    }
    disconnectWaba(wabaId: string) {
        return this.http.post<MetaConnectionStatusResult>(
            `${this.route}/wabas/${wabaId}/disconnect`,
        );
    }
    migrateWaba(wabaId: string) {
        return this.http.post<MetaConnectionStatusResult>(`${this.route}/wabas/${wabaId}/migrate`);
    }
}

export default new MetaIntegrationService();
